import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  get_headers,
  RETRIEVE_SERVICES,
  GET_LEAD_FORM_WITH_ANSWERS
}  from '@/utils/constants/constants.js';
import axios from 'axios';


export default {
  name: "VerificationResults",
  mixins: [alert_mixin],
  props: {
    profile_role_form_id: {
        type: [String, Number],
        required: true
    }
  },
  components: {
    NavigationBackButton,
    GlobalTable,
  },

  watch: {
  profile_role_form_id: {
    handler(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.get_lead_form_answers();
      }
    },
    immediate: false
  }
},
  data: () => ({
    headers: get_headers(),
    expanded_service: null,
    lead_id: null,
    active_tabs: ['Forms'],
    last_updated: "Jul 31, 2025",
    form_name: '',
    verification_services: [],
    expanded_cards: [],
    active_main_tab: 'Answers',
    form_data: null,
    loading_form: false,
    sections: [],
    expanded_sections: [],
    main_tabs: [
      {
        label: "Answers",
      },
      {
        label: "Verification",
      },
    ],
    verification_results: [
        {
            type: "idv",
            label: "IDV Results",
            date: "Apr 1, 2023",
            status: "Verified",
            details: {
                status: "Verified",
                name_match: "John Doe",
                verification_id: "IDV-001",
                officer: "Auto Verification",
                priority: "High"
            }
        },
        {
            type: "cipc",
            label: "CIPC Results",
            date: "Apr 1, 2023",
            status: "Failed",
            details: {
                status: "Failed",
                company: "ABC PTY LTD",
                registration_number: "2019/123456/07",
                officer: "System Auto",
                priority: "Normal"
            }
        },
        {
            type: "directors",
            label: "Directors Search",
            date: "Apr 1, 2023",
            status: "Pending",
            details: {
                directors: ["Jane Doe", "John Smith"],
                count: 2,
                source: "CIPC"
            }
        },
        {
            type: "address",
            label: "Address Search",
            date: "Apr 1, 2023",
            status: "Pending",
            details: {
                address: "123 Main St, Sandton, 2196",
                verified: false,
                geocode_match: "Low"
            }
        }
    ],
  }),
  mounted() {
    this.lead_id =
            this.$route.params.lead_id ??
            this.$route.params.id ??
            this.$route.query.lead_id ??
            null;

        if (!this.lead_id) {
            this.show_error("No lead ID found. Check your route.");
        }

    this.get_services();
    this.get_lead_form_answers();
  },
  methods: {
    toggle_tab(tab) {
      if (this.active_tabs.includes(tab)) {
        this.active_tabs = this.active_tabs.filter(t => t !== tab);
      } else {
        this.active_tabs.push(tab);
      }
    },
    redirect_to_verification_results() {
      this.$router.push({
        path: "/verification_results",
      });
    },
    format_key(str) {
      return str.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },

    toggle_service_details(index) {
        this.expanded_service = this.expanded_service === index ? null : index;
    },

    get_service_icon(type) {
        if (type === 'idv') {
            return 'bi-person-check';
        } else if (type === 'cipc') {
            return 'bi-building-check';
        } else if (type === 'directors') {
            return 'bi-people';
        } else if (type === 'address') {
            return 'bi-geo-alt';
        } else {
            return 'bi-file-earmark';
        }
    },

    get_servicecard_class(status) {
        if (status === 'Verified') return 'verified';
        if (status === 'Pending') return 'pending';
        if (status === 'Failed') return 'failed';
        return '';
    },

    get_services() {
      axios.get(RETRIEVE_SERVICES, {
        headers: this.headers,
      })
      .then(response => {
        const parsed_response = JSON.parse(response.data);
        if (parsed_response.status === "success" && parsed_response.data) {
          this.verification_services = parsed_response.data.map(service => ({
            ...service,
            selected: false
          }));
        } else {
          this.verification_services = [];
        }
      })
      .catch(error => {
        this.show_error("Error loading services: " + (error.response?.data?.message || error.message));
      });
    },

    get_lead_form_answers() {
      if (!this.profile_role_form_id) {
        return;
      }

      this.loading_form = true;

      axios.get(GET_LEAD_FORM_WITH_ANSWERS, {
        headers: this.headers,
        params: {
          lead_form_id: this.profile_role_form_id
        }
      })
      .then(response => {
        const parsed_response = typeof response.data === 'string' 
          ? JSON.parse(response.data) 
          : response.data;

        if (parsed_response.status === "success" && parsed_response.data) {
          this.form_data = parsed_response.data;
          this.form_name = parsed_response.data.form_name;
          
          this.sections = parsed_response.data.sections || [];
          this.expanded_sections = this.sections.map(() => true);
        } else {
          this.show_error(parsed_response.message || "Failed to load form answers");
        }
      })
      .catch(error => {
        this.show_error("Error loading form answers: " + (error.response?.data?.message || error.message));
      })
      .finally(() => {
        this.loading_form = false;
      });
    },

    get_question_input_type(question_type) {
      const type = question_type?.question_type?.toLowerCase() || '';
      if (type === 'short_text') return 'text';
      if (type === 'long_text') return 'textarea';
      if (type === 'date') return 'date';
      if (type === 'single_select') return 'radio';
      if (type === 'multi_select') return 'checkbox';
      
      return 'text';
    },

    toggle_card(index) {
        if (this.expanded_cards.includes(index)) {
        this.expanded_cards = this.expanded_cards.filter(i => i !== index);
        } else {
        this.expanded_cards.push(index);
        }
    },

    toggle_section(index) {
      const current = Reflect.get(this.expanded_sections, index);
      Reflect.set(this.expanded_sections, index, !current);
    },

    is_section_open(index) {
      return Reflect.get(this.expanded_sections, index) || false;
    }

  },
};